<div id="content" class="allcp-form" ng-controller="SalesPaymentController" ng-init="payments()">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <header class="navbar navbar-fixed-top subnavbar bg-system">
        <ul class="nav navbar-nav navbar-left">
            <div class="form-group floating">
                <input type="text" class="btn btn-operation text-input form-control" ng-model="filterData.term" placeholder="By Name">
                <label>By Name</label>
            </div>

            <div class="form-group">
                <a href="#"
                   class="btn w50 p-2 ml10"
                   ng-show="filterData.date.startDate || filterData.term || filterData.status"
                   ng-click="refreshData('map')">
                    <i class="fa fa-refresh"></i>
                </a>
            </div>
            <div class="form-group"
                 ng-show="filterData.date.startDate || filterData.term || filterData.status">
                <a href="#" class="clear-filter ml-3" ng-click="clearFilter()">
                    Clear Filter
                </a>
            </div>
          
        </ul>
    </header>
    <div class="panel-body">
        <div style="width:100%">
            <div class="table-responsive" ng-if="data.payments.data.length > 0">
                <div id="scrollable-area">
                <table class="table table-hover tc-checkbox-1" fixed-table-headers="scrollable-areas">
                    <thead>
                    <tr class="bg-light">
                        <th>
                        </th>
                        <th style="min-width: 120px;">Merthant Name</th>
                        <th style="min-width: 100px;">Description</th>
                        <th style="min-width: 150px;">Payment Date</th>
                        <th style="min-width: 120px;">
                            Status
                            <a ng-click="sort('status','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('status','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th></th>        
                    </tr>
                    </thead>
                    <tbody>
                        <tr
                            dir-paginate="item in data.payments.data | itemsPerPage: filterData.paginate"
                            total-items="data.payments.total"
                            current-page="data.payments.current_page"
                            ng-class="{'checked': selectedItems.indexOf(item.id) > -1}"
                        >
                        <td class="clickable-row">
                            <!-- <label class="option block mn">
                                <input type="checkbox" ng-click="checkBilling(item.id)" ng-checked="selectedItems.indexOf(item.id) !== -1" id="checkboxDefault-{{item.id}}">
                                <span class="checkbox mn"></span>
                            </label> -->
                        </td>
                        <td>{{ item.customer.customer_name }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.pament_date | amDateFormat:'MM/DD/YYYY' }}</td>
                        <td>
                            <span ng-if="item.status == 'pending'">Pending</span>
                            <span ng-if="item.status != 'pending'" style="color: rgb(43, 191, 201);">Paid</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
                <div class="paginate-area">
                    <div class="row">
                        <div class="col-11">
                            <dir-pagination-controls
                                boundary-links="true"
                                on-page-change="getPage(newPageNumber)"
                                template-url="dirPagination.tpl.html"
                                class="pagination-lg pagination pull-right pr10">
                            </dir-pagination-controls>
                        </div>
                        <div class="col-1 pl0">
                            <select class="form-control"
                                ng-model="filterData.paginate"
                                ng-change="filter()"
                                ng-options="pageSize for pageSize in pageSizes"
                                >
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center mt50" ng-if="isEmpty">
                <div>
                    <img src="img/empty_page_orange.svg" alt="" width="400px">
                    <br>
                    <h3 style="font-size: 48px;font-weight: 800;">No payment yet</h3>
                </div>
            </div>
        </div>
    </div>
    
    <div class="navbar fixed-panel-footer" ng-if="selectedItems.length">
        <div class="nav navbar-nav navbar-left">
            <a href="#" ng-click="selectAllBilling(true)" class="btn mr-2 btn-outline">Select All</a>
            <a href="#" ng-click="selectAllBilling(false)" class="btn btn-outline">Unselect</a>
        </div>
        <div class="nav navbar-nav navbar-center">
        </div>
        <div class="nav navbar-nav navbar-right">
            <a href="/print-invoice/{{ selectedItems.join(',') }}"
                target="__BLANK"
                class="btn btn-outline">Print {{ selectedItems.length > 1 ? 'Invoices' : 'Invoice'  }}</a>
            <!-- <a href="#" ng-click="printInvoice()" class="btn btn-outline">Print {{ selectedItems.length }} Invoice</a> -->
        </div>
    </div>
</div>
